import React from "react";
import Nav from "../components/Nav";
import Footer from "../components/Footer";

const Layout = ({ children }) => {
  return (
    <div className="">
      <Nav />
      <section className="mt-[105px]">{children}</section>
      <Footer />
    </div>
  );
};

export default Layout;
